module.exports = __webpack_public_path__ + "img/hand-swipe.ad67847b.png";